export const ONBOARDING_STEPS = [
    { id: 'welcome', label: 'Welcome', route: '/user/compose' },
    { id: 'compose_input', label: 'AI Composer', route: '/user/compose', pageTarget: 'compose-input' },
    { id: 'nav_screens', label: 'Screens', route: '/user/compose', navTarget: 'nav-screens' },
    { id: 'nav_library', label: 'Library', route: '/user/compose', navTarget: 'nav-library' },
    { id: 'install_app', label: 'TV setup', route: '/user/compose' },
    { id: 'done', label: 'Done', route: '/user/compose' },
];

export const ONBOARDING_SEQUENCE = [
    'welcome',
    'compose_input',
    'nav_screens',
    'nav_library',
    'install_app',
    'done',
];

export function getNextOnboardingStepId(completedSteps) {
    const done = new Set(completedSteps || []);
    for (const id of ONBOARDING_SEQUENCE) {
        if (!done.has(id)) {
            return id;
        }
    }
    return null;
}
